<form [formGroup]="form" class="form-app-preferences" (click)="onTouched()">
  <div class="text-container">
    <div>
      @if (showInfo) {
        <ion-label class="title">{{ 'onboarding.company.info' | transloco }}</ion-label>
      }
      <c-input
        [label]="'onboarding.company.name' | transloco" formControlName="name"
        [readonly]="isReadOnly"
        [noBorder]="isReadOnly" />
      <c-input
        [label]="'onboarding.company.coc-number' | transloco" formControlName="companyNumber"
        [readonly]="isReadOnly"
        [noBorder]="isReadOnly" />
      <c-input
        [label]="'onboarding.company.vat-number' | transloco" formControlName="vatNumber"
        [readonly]="isReadOnly"
        [noBorder]="isReadOnly" />
    </div>
  </div>
</form>
